const authChannel = new BroadcastChannel('auth')

export function broadcastLogin(usuarioId: number) {
  authChannel.postMessage({ type: 'LOGIN', usuarioId })
}

export function broadcastLogout() {
  authChannel.postMessage({ type: 'LOGOUT' })
}

export function broadcastCursoChange(cursoId: number) {
  authChannel.postMessage({ type: 'CURSO_CHANGE', cursoId })
}

export function onCursoChange(callback: (cursoId: number) => void) {
  const handler = (event: MessageEvent) => {
    if (event.data?.type === 'CURSO_CHANGE') callback(event.data.cursoId)
  }
  authChannel.addEventListener('message', handler)
  return () => authChannel.removeEventListener('message', handler)
}

export function onAuthChange(
  callback: (msg: { type: string; usuarioId?: number; cursoId?: number }) => void
) {
  const handler = (event: MessageEvent) => callback(event.data)
  authChannel.addEventListener('message', handler)
  return () => authChannel.removeEventListener('message', handler)
}
